import styled from 'styled-components'

export const config = {
  defaultSize: 16,
}

export const SpinnerUI = styled('div')`
  --hsds-spinner-size: ${config.defaultSize}px;
  display: block;
  width: var(--hsds-spinner-size);
  height: var(--hsds-spinner-size);
`

export const SpinnerSVGUI = styled('svg')`
  --hsds-spinner-speed: 1400ms;
  animation: SpinnerUIAnimation var(--hsds-spinner-speed) linear infinite;
  display: block;
  width: var(--hsds-spinner-size);
  height: var(--hsds-spinner-size);
  will-change: transform;

  @keyframes SpinnerUIAnimation {
    100% {
      transform: rotate(360deg);
    }
  }
`

export const SpinnerCircleUI = styled('circle')`
  --hsds-spinner-circle-stroke: currentColor;
  animation: SpinnerCircleUIAnimation var(--hsds-spinner-speed) ease-in-out
    infinite;
  display: block;
  fill: transparent;
  opacity: 1;
  stroke: var(--hsds-spinner-circle-stroke);
  stroke-width: 3.6;
  stroke-linecap: rounded;
  stroke-dasharray: 80px, 200px;
  stroke-dashoffset: 0px;
  will-change: transform, stroke-dashoffset;

  &:not(.is-rounded) {
    stroke-linecap: square;
  }

  @keyframes SpinnerCircleUIAnimation {
    0% {
      stroke-dasharray: 1px, 200px;
      stroke-dashoffset: 0px;
      opacity: 0;
    }
    0.1% {
      opacity: 1;
    }
    50% {
      stroke-dasharray: 100px, 200px;
      stroke-dashoffset: -15px;
    }
    100% {
      stroke-dasharray: 100px, 200px;
      stroke-dashoffset: -125px;
    }
  }
`
